import React, { useState, useCallback, useEffect } from "react";
import { Link } from "react-router-dom";
import Frame222 from "../Frame222";
import jsPDF from "jspdf";
import "./Analysis.css";

// ==============================
//     CONFIG API
// ==============================
const API_URL = process.env.REACT_APP_API_URL;
const MODEL_KEYWORDS = {
  "Functional View": "functional",
  "Process View": "process",
  "Physical View": "physical",
  "Decisional View": "decisional",
  "Information Model": "information",
};
const MANAGEMENT_KEYWORDS = {
  "VSM": "vsm",
  "5S": "5s",
  "Kaizen": "kaizen",
  "SMED": "smed",
  "Kanban": "kanban",
  "Visual Management": "visual"
};

function Analysis(props) {
  const { place, formalismesEnFonct, frame222Props } = props;

  // à‰tats principaux
  const [activeTab, setActiveTab] = useState("acquisition");
  const [activeCase, setActiveCase] = useState(null);
  const [enterpriseScores, setEnterpriseScores] = useState(null);
  const [result, setResult] = useState(null);

  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const [loadingCase, setLoadingCase] = useState(true);
  const [loadingScores, setLoadingScores] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedManagement, setSelectedManagement] = useState(null);
  const [domainReport, setDomainReport] = useState(null);
  const [domainDetailedReport, setDomainDetailedReport] = useState(null);
  const [modelReport, setModelReport] = useState(null);
  const [managementReport, setManagementReport] = useState(null);

  // IDs stockés localement
  const activeCaseId = localStorage.getItem("caseId");
  const activeEnterpriseId = localStorage.getItem("activeEnterpriseId");
  const token = localStorage.getItem("token");

  // ==============================
  // 1ï¸âƒ£ Chargement du cas actif
  // ==============================
  const fetchActiveCase = useCallback(async () => {
    if (!activeCaseId) {
      setLoadingCase(false);
      setErrorMessage("Aucun cas actif sélectionné.");
      return;
    }

    try {
      setLoadingCase(true);
      const response = await fetch(`${API_URL}/api/case-details/${activeCaseId}`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });

      if (!response.ok) throw new Error("Impossible de charger le cas actif.");

      const data = await response.json();
      if (!data.found) throw new Error("Cas introuvable cà´té serveur.");

      setActiveCase(data.case);

    // ðŸ‘‡ AJOUT OBLIGATOIRE POUR CORRIGER LE SPAM 404
    if (data.case.enterpriseId) {
      localStorage.setItem("activeEnterpriseId", data.case.enterpriseId);
    }

    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingCase(false);
    }
  }, [activeCaseId, token]);

  // ==============================
  // 2ï¸âƒ£ Chargement des scores
  // ==============================
  const fetchEnterpriseScores = useCallback(async () => {
  if (!activeEnterpriseId) return;

  try {
    setLoadingScores(true);
    const response = await fetch(`${API_URL}/api/enterprise-scores/${activeEnterpriseId}`);

    if (response.status === 404) {
      console.warn("Aucun score trouvé pour cet ID");
      setEnterpriseScores(null);
      return;
    }

    if (!response.ok) {
      throw new Error("Erreur lors du chargement des scores.");
    }

    const data = await response.json();
    setEnterpriseScores(data);  // <-- LA VERSION CORRECTE
  } catch (err) {
    console.error("Erreur scores:", err);
    setEnterpriseScores(null);
  } finally {
    setLoadingScores(false);
  }
  }, [activeEnterpriseId]);

  // Chargement initial
  useEffect(() => {
    fetchActiveCase();
    fetchEnterpriseScores();
  }, [fetchActiveCase, fetchEnterpriseScores]);

  // ðŸ”„ Recharge les scores quand le case est chargé
  useEffect(() => {
    if (activeCase?.enterpriseId) {
      fetchEnterpriseScores();
    }
  }, [activeCase]);

  // ==============================
  // 3ï¸âƒ£ UPLOAD IMAGE â€” Acquisition
  // ==============================
  const handleFileUpload = useCallback(async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setUploadStatus("Erreur : fichier non valide.");
      return;
    }

    try {
      setIsUploading(true);
      setUploadStatus("Téléchargement en cours...");

      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${API_URL}/upload`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Erreur serveur pendant l'upload.");

      setUploadStatus("Image importée avec succès !");
    } catch (error) {
      setUploadStatus(`Erreur : ${error.message}`);
    } finally {
      setIsUploading(false);
    }
  }, []);

  // ==============================
  // 4ï¸âƒ£ Drag & Drop
  // ==============================
  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (["dragenter", "dragover"].includes(e.type)) setDragActive(true);
    if (e.type === "dragleave") setDragActive(false);
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      if (e.dataTransfer.files?.[0]) {
        handleFileUpload({ target: { files: e.dataTransfer.files } });
      }
    },
    [handleFileUpload]
  );

  // ==============================
  // 5ï¸âƒ£ Exécution PyKE â€” MODELES
  // ==============================
  const inference = useCallback(async () => {
    try {
      setIsUploading(true);
      setUploadStatus("Analyse PyKE en cours...");
      setResult(null);

      const response = await fetch(`${API_URL}/inferences`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        if (response.status === 404) throw new Error("Aucun fichier trouvé.");
        throw new Error("Erreur backend PyKE.");
      }

      const data = await response.json();
      if (data.errors) setResult(data.errors);
      else if (data.message) setResult([data.message]);
      else throw new Error("Réponse PyKE invalide.");

      setUploadStatus("Analyse terminée !");
    } catch (err) {
      setUploadStatus(`Erreur : ${err.message}`);
    } finally {
      setIsUploading(false);
    }
  }, []);

  // ==============================
  // 6ï¸âƒ£ Génération PDF
  // ==============================
  const saveAsPDF = useCallback(() => {
    if (!result?.length) return;

    const pdf = new jsPDF();
    let y = 20;

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(18);
    pdf.text("Rapport d'Analyse PyKE", 105, y, { align: "center" });

    y += 20;
    pdf.setLineWidth(0.5);
    pdf.line(10, y, 200, y);
    y += 10;

    result.forEach((err, index) => {
      const text = typeof err === "string" ? err : JSON.stringify(err);
      const lines = pdf.splitTextToSize(`${index + 1}. ${text}`, 180);

      if (y + lines.length * 8 > 280) {
        pdf.addPage();
        y = 20;
      }

      pdf.text(lines, 10, y);
      y += lines.length * 8;
    });

    pdf.save("analyse_pyke.pdf");
  }, [result]);

  // ==============================
  // 7ï¸âƒ£ RENDU DES SECTIONS
  // ==============================

  const fetchFullAcquisitionReport = useCallback(async () => {
    if (!selectedDomain || !activeEnterpriseId) return;

    try {
      setLoadingScores(true);
      setDomainReport(null);
      setDomainDetailedReport(null);

      // 1ï¸âƒ£ Detailed + vrai score calculé cà´té backend
      const detailedRes = await fetch(
        `${API_URL}/expert/evaluate?enterpriseId=${activeEnterpriseId}&domain=${encodeURIComponent(
          selectedDomain
        )}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([]), // pas de faits PyKE pour lâ€™instant
        }
      );

      if (!detailedRes.ok) {
        throw new Error("Erreur Detailed Report");
      }

      const detailedData = await detailedRes.json();

      // questions NO + suggestions
      setDomainDetailedReport(detailedData.mongo_data || []);

      // âœ… score calculé avec : (Yes * 20 / total)
      const score = detailedData.score || 0;

      // 2ï¸âƒ£ Global report basé sur ce score
      const globalRes = await fetch(
        `${API_URL}/expert/global-report?domain=${encodeURIComponent(
          selectedDomain
        )}&score=${score}`
      );

      if (!globalRes.ok) {
        throw new Error("Erreur Global Report");
      }

      const globalData = await globalRes.json();
      setDomainReport(globalData);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedDomain, activeEnterpriseId]);

  const renderAcquisition = () => (
    <section className="analysis-section">
      <h3 className="section-title"> Acquisition</h3>
      <p className="section-subtitle">Choose a domain to analyse.</p>

      {/* --------- LES 7 DOMAINES --------- */}
      <div className="acq-buttons-grid">
        {[
          "Environmental",
          "Social",
          "Modernization",
          "Lead Time",
          "Cost",
          "Quality",
          "Client Consumer",
        ].map((domain) => (
          <button
            key={domain}
            className={`acq-btn ${selectedDomain === domain ? "active" : ""}`}
            onClick={() => setSelectedDomain(domain)}
          >
            {domain}
          </button>
        ))}
      </div>

      {/* --- REPORT BLOCK (only if selected) --- */}
      {selectedDomain && (
        <div className="report-section">
          <div className="report-header">
            <span className="report-icon"></span>
            <span className="report-title">Reports for {selectedDomain}</span>
          </div>
          <div className="report-buttons">
            <button className="report-btn" onClick={fetchFullAcquisitionReport}>
              Generate report
            </button>
          </div>
          {domainReport && (
            <div className="global-report-box">
              <h4>Global Report</h4>
              <p><strong>Domain:</strong> {domainReport.domain}</p>
              <p><strong>Score:</strong> {domainReport.score}</p>
              <p>{domainReport.global_message}</p>
            </div>
          )}
          {domainDetailedReport && (
          <div className="detailed-report-box">
            <h4>Detailed Report</h4>

            {domainDetailedReport.length === 0 ? (
              <p>No issues found for this domain.</p>
            ) : (
              domainDetailedReport.map((item, idx) => (
                <div key={idx} className="detailed-item">
                  <p><strong>Question:</strong> {item.question}</p>
                  <p><strong>Answer:</strong> {item.answer}</p>
                  <p><strong>Suggestion:</strong> {item.suggestion}</p>
                  <hr />
                </div>
              ))
            )}
    </div>
  )}

        </div>
      )}
    </section>
  );

  const fetchModelReport = useCallback(async () => {
    if (!selectedModel) return;

    try {
      setLoadingScores(true);
      setModelReport(null);

      // ðŸ”¥ ON UTILISE LE BON MOT-CLà‰
      const mappedKeyword = MODEL_KEYWORDS[selectedModel];

      const response = await fetch(
        `${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`
      );

      if (!response.ok) throw new Error("Erreur lors de l'analyse des modèles.");

      const data = await response.json();
      setModelReport(data);

    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedModel]);

  const renderModeles = () => (
    <section className="analysis-section">
      <h3 className="section-title">Models</h3>
      <p className="section-subtitle">Choose a model to analyse.</p>

      <div className="model-buttons-grid">
        {[
          "Functional View",
          "Process View",
          "Physical View",
          "Decisional View",
          "Information Model",
        ].map((name) => (
          <button
            key={name}
            className={`model-btn ${selectedModel === name ? "active" : ""}`}
            onClick={() => setSelectedModel(name)}
          >
            {name}
          </button>
        ))}
      </div>

      {selectedModel && (
        <div className="report-section">
          <div className="report-header">
            <span className="report-icon"></span>
            <span className="report-title">Reports for {selectedModel}</span>
          </div>

          <div className="report-buttons">
            <button className="report-btn" onClick={fetchModelReport}>
              Generate analysis
            </button>
          </div>

          {/* ===== RESULTATS ===== */}
          {modelReport && (
            <>
              <div className="global-report-box">
                <h4>Model Analysis Summary</h4>
                <p><strong>View Type:</strong> {modelReport.view_type}</p>
                <p><strong>PDFs analyzed:</strong> {modelReport.pdf_found_count}</p>
              </div>

              {modelReport.results.map((pdf, index) => (
                <div key={index} className="detailed-report-box">
                  <h4>{pdf.filename}</h4>
                  <p><strong>Nodes:</strong> {pdf.nodes}</p>
                  <p><strong>Arrows:</strong> {pdf.arrows}</p>
                  <p><strong>Total Shapes:</strong> {pdf.total_shapes}</p>
                  <p><strong>Score:</strong> {pdf.score} / 20</p>
                  <p><strong>Interpretation:</strong> {pdf.interpretation}</p>

                  <h4>Rules Evaluation</h4>
                  {pdf.rules_evaluation.map((rule, idx) => (
                    <div key={idx} className="detailed-item">
                      <p><strong>Rule:</strong> {rule.rule}</p>
                      <p><strong>Status:</strong> {rule.passed ? "âœ… Passed" : "âŒ Failed"}</p>
                      <p><strong>Detail:</strong> {rule.detail}</p>
                      <hr/>
                    </div>
                  ))}
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </section>
  );

  const fetchManagementReport = useCallback(async () => {
    if (!selectedManagement) return;

    try {
      setLoadingScores(true);
      setManagementReport(null);

      const mappedKeyword = MANAGEMENT_KEYWORDS[selectedManagement];

      const response = await fetch(
        `${API_URL}/expert/analyse-pdf-by-name?keyword=${mappedKeyword}`
      );

      if (!response.ok)
        throw new Error("Erreur lors de lâ€™analyse du management.");

      const data = await response.json();
      setManagementReport(data);

    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoadingScores(false);
    }
  }, [selectedManagement]);

  const renderManagements = () => (
    <section className="analysis-section">
      <h3 className="section-title">Managements</h3>
      <p className="section-subtitle">Choose a lean management tool.</p>

      <div className="management-buttons-grid">
        {[
          "VSM",
          "5S",
          "Kaizen",
          "SMED",
          "Kanban",
          "Visual Management",
        ].map((tool) => (
          <button
            key={tool}
            className={`mgmt-btn ${selectedManagement === tool ? "active" : ""}`}
            onClick={() => setSelectedManagement(tool)}
          >
            {tool}
          </button>
        ))}
      </div>

      {selectedManagement && (
        <div className="report-section">
          <div className="report-header">
            <span className="report-icon"></span>
            <span className="report-title">Reports for {selectedManagement}</span>
          </div>

          <div className="report-buttons">
            <button className="report-btn" onClick={fetchManagementReport}>
              Generate analysis
            </button>
          </div>

          {/* ===== RESULTATS ===== */}
          {managementReport && (
            <>
              <div className="global-report-box">
                <h4>Management Tool Analysis Summary</h4>
                <p><strong>Keyword:</strong> {managementReport.view_type}</p>
                <p><strong>PDFs analyzed:</strong> {managementReport.pdf_found_count}</p>
              </div>

              {managementReport.results.map((pdf, index) => (
                <div key={index} className="detailed-report-box">
                  <h4>{pdf.filename}</h4>
                  <p><strong>Nodes:</strong> {pdf.nodes}</p>
                  <p><strong>Arrows:</strong> {pdf.arrows}</p>
                  <p><strong>Total Shapes:</strong> {pdf.total_shapes}</p>
                  <p><strong>Score:</strong> {pdf.score} / 20</p>
                  <p><strong>Interpretation:</strong> {pdf.interpretation}</p>

                  <h4>Rules Evaluation</h4>
                  {pdf.rules_evaluation.map((rule, idx) => (
                    <div key={idx} className="detailed-item">
                      <p><strong>Rule:</strong> {rule.rule}</p>
                      <p><strong>Status:</strong> {rule.passed ? "âœ… Passed" : "âŒ Failed"}</p>
                      <p><strong>Detail:</strong> {rule.detail}</p>
                      <hr />
                    </div>
                  ))}
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </section>
  );

  // ==============================
  // 8ï¸âƒ£ RENDU FINAL
  // ==============================
  return (
    <>
    <div className="analysis-container">
      <main className="analysis-main">
        <section className="case-header">
          <div className="case-card improved-case-card">
            
            <h2 className="case-title improved-case-title">
              {activeCase?.company_name || "Active case"}
            </h2>

            <p className="case-subtitle improved-case-subtitle">
              {activeCase ? (
                <>
                  <span className="case-info-item">
                    Sector :
                    <strong> {activeCase.activity_sector || "N/A"}</strong>
                  </span>

                  <span className="case-divider"></span>

                  <span className="case-info-item">
                    Company size :
                    <strong> {activeCase.company_size || "N/A"}</strong>
                  </span>
                </>
              ) : (
                "No case selected"
              )}
            </p>

            {/* ðŸ“… Created on */}
            {activeCase && (
              <p className="case-created improved-case-created">
                Created on :{" "}
                <strong>
                  {activeCase.date_created ||
                    activeCase.timestamp ||
                    "Unknown date"}
                </strong>
              </p>
            )}

            <p className="case-id-display improved-case-id">
              Case ID : <strong>{activeCaseId || "â€”"}</strong>
            </p>

            {errorMessage && (
              <p className="case-error improved-case-error">{errorMessage}</p>
            )}
          </div>
        </section>

        {/* Navigation onglets */}
        <section className="tabs-section">
          <button className={`tab-button ${activeTab === "acquisition" ? "active" : ""}`} onClick={() => setActiveTab("acquisition")}> Acquisition</button>
          <button className={`tab-button ${activeTab === "modeles" ? "active" : ""}`} onClick={() => setActiveTab("modeles")}>Models</button>
          <button className={`tab-button ${activeTab === "managements" ? "active" : ""}`} onClick={() => setActiveTab("managements")}>Managements</button>
        </section>

        {/* Contenu */}
        {activeTab === "acquisition" && renderAcquisition()}
        {activeTab === "modeles" && renderModeles()}
        {activeTab === "managements" && renderManagements()}
      </main>
    </div>
  
    {/* âœ… Navigation */}
          <div className="icam-navigation">
            <Link to="/pdf-uploader">
              <button className="icam-nav-btn">Back to saving</button>
            </Link>
            <Link to="/conception">
              <button className="icam-nav-btn">Move to conception</button>
            </Link>
          </div>
    </>

  );
}

export default Analysis;